/**
 * Schema of PosicaoMotorista
 * @author Simpli CLI generator
 */
import {InputType, Schema} from 'simpli-web-sdk'
import {datetime} from 'simpli-web-sdk'
import PosicaoMotorista from '@/model/resource/PosicaoMotorista'
import RenderLabelValue from '@/components/render/RenderLabelValue.vue'
import RenderCargaDanfe from '@/components/render/carga/RenderCargaDanfe.vue'
import RenderValueWithPopOver from '@/components/render/RenderValueWithPopOver.vue'

export default (model: PosicaoMotorista): Schema => ({
  idPosicaoPk: {
    content: model.idPosicaoPk,
    editable: false,
    hidden: true,
  },

  motorista: {
    content: model.motorista.$tag,
  },

    placaVeiculo: {
        content: model.motorista.placaVeiculo,
    },

  nroNotaFiscal: {
    content: model.carga.nroNotaFiscal,
  },

  danfe: {
    content: {
      component: RenderCargaDanfe,
      props: {
        danfe: model.carga.danfe,
      },
    },
  },

  statusCarga: {
    content: {
      component: RenderLabelValue,
      props: {
        value: model.carga.statusCarga && model.carga.statusCarga.$tag || '-',
        tagClass: model.carga.statusCargaTagClass,
      },
    },
  },

  embarcador: {
    content: model.carga.embarcador.responsavel.$tag,
  },

  transportador: {
    content: model.carga.transportador.responsavel.$tag,
  },

  destinatario: {
    content: model.carga.destinatario.$tag,
  },

  endereco: {
    content: model.enderecoAlternativo || (model.carga.endereco && model.carga.endereco.toString()) || '',
  },

  data: {
    content: datetime(model.carga.dataInicioEntrega),
  },

  latitude: {
    content: model.latitude,
    hidden: true,
  },

  longitude: {
    content: model.longitude,
    hidden: true,
  },

  geoposicionamento: {
    content: datetime(model.data) || '-',
  },

  centroDeCusto: {
    content: model.carga.centroDeCusto && model.carga.centroDeCusto.nome || '-',
  },
})
